import {
  Text,
  Section,
  Row,
  Column,
  Img,
  Link,
  Container,
} from '@react-email/components';
import { KYDEventBlockData } from '../../interfaces/KYDCampaign';
import dayjs from 'dayjs';
import { replaceCampaignVariables } from '../../services/util/campaigns';
import { createTrackableLink } from '../utils/link';

const Events = ({
  events = [],
  campaign_id,
}: {
  events?: KYDEventBlockData[];
  campaign_id?: string;
}) => {
  const renderCard = (eventData: KYDEventBlockData, idx: number) => {
    if (!eventData?.event) {
      return null;
    }

    let link = createTrackableLink(eventData.event?.link, {
      utm_source: 'kyd',
      utm_medium: 'email',
    });

    if (campaign_id) {
      link = createTrackableLink(link, {
        utm_campaign: campaign_id,
        utm_source: 'kyd',
        utm_medium: 'email',
        utm_id: campaign_id,
      });
    }

    const image = eventData.custom_image || eventData.event!.image;

    return (
      <Container
        key={idx}
        style={{
          width: '100%',
          marginBottom: '12px',
          borderTop: '1px solid #00000033',
          paddingTop: '10px',
        }}
      >
        <Link href={link} style={{ textDecoration: 'none' }}>
          <Text
            style={{
              fontSize: '12px',
              fontWeight: 600,
              color: '#000000B2',
              fontFamily: 'Inter, sans-serif',
              marginBottom: '12px',
              marginTop: '0px',
            }}
          >
            {eventData.event!.start_at
              ? dayjs(eventData.event!.start_at).format('MMMM D, YYYY')
              : 'Event Date'}
          </Text>
          <Text
            style={{
              marginTop: '0px',
              fontSize: '14px',
              fontWeight: 700,
              lineHeight: '120%',
              color: '#000000',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            {eventData.event!.name}
          </Text>
          {image ? (
            <Link href={link} style={{ textDecoration: 'none' }}>
              <Img
                src={image}
                alt={eventData.event!.name}
                style={{
                  width: '100%',
                  aspectRatio: '1/1',
                  borderRadius: '2px',
                  objectFit: 'cover',
                  boxShadow: '0px 15px 10px 0px rgba(0,0,0,0.05)',
                  marginBottom: '12px',
                }}
              />
            </Link>
          ) : (
            <Container
              style={{
                width: '100%',
                aspectRatio: '1/1',
                borderRadius: '2px',
                backgroundColor: '#FFF',
                border: '1px dashed rgba(0, 0, 0, 0.50)',
                textAlign: 'center',
                padding: '50% 0',
              }}
            >
              <Text
                style={{
                  color: 'rgba(0, 0, 0, 0.70)',
                  fontSize: '12px',
                  fontFamily: 'Inter, sans-serif',
                  margin: '0',
                  fontWeight: 600,
                  lineHeight: '0',
                }}
              >
                image
              </Text>
            </Container>
          )}
          {eventData.door_time && (
            <Row style={{ marginBottom: '4px' }}>
              <Column style={{ width: '50%' }}>
                <Text style={InfoStyle}>Doors</Text>
              </Column>
              <Column style={{ width: '50%', textAlign: 'right' }}>
                <Text style={InfoStyle}>
                  {dayjs(eventData.door_time).format('h:mm A')}
                </Text>
              </Column>
            </Row>
          )}

          {eventData.show_time && (
            <Row>
              <Column style={{ width: '50%' }}>
                <Text style={InfoStyle}>Show</Text>
              </Column>
              <Column style={{ width: '50%', textAlign: 'right' }}>
                <Text style={InfoStyle}>
                  {dayjs(eventData.show_time).format('h:mm A')}
                </Text>
              </Column>
            </Row>
          )}
          <Link
            href={link}
            style={{
              marginTop: '12px',
              display: 'block',
              padding: '12px',
              borderRadius: '4px',
              backgroundColor: '#111111',
              color: '#ffffff',
              textDecoration: 'none',
              fontSize: '12px',
              fontWeight: 600,
              textAlign: 'center',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            {eventData.button_text}
          </Link>
          <Text style={BodyStyle}>
            {replaceCampaignVariables(eventData.body, eventData)}
          </Text>
        </Link>
      </Container>
    );
  };

  return (
    <Section style={{ maxWidth: '600px', margin: '0px auto' }}>
      <div>
        {events.length === 1 ? (
          <Row>{renderCard(events[0], 0)}</Row>
        ) : (
          Array.from({ length: Math.ceil(events.length / 2) }).map(
            (_, rowIdx) => (
              <Row key={`drow-${rowIdx}`} style={{ marginBottom: '12px' }}>
                {events.slice(rowIdx * 2, rowIdx * 2 + 2).map((ev, colIdx) => (
                  <Column
                    key={`dcol-${rowIdx}-${colIdx}`}
                    style={{
                      width: '50%',
                      verticalAlign: 'top',
                      padding: colIdx === 0 ? '0 6px 0 0' : '0 0 0 6px',
                    }}
                  >
                    {renderCard(ev, rowIdx * 2 + colIdx)}
                  </Column>
                ))}
              </Row>
            ),
          )
        )}
      </div>
    </Section>
  );
};

const InfoStyle: React.CSSProperties = {
  fontSize: '12px',
  fontWeight: 600,
  color: '#000000B2',
  fontFamily: 'Inter, sans-serif',
  lineHeight: '130%',
  marginBottom: '4px',
  marginTop: '0px',
  borderBottom: '1px solid #00000033',
};

const BodyStyle: React.CSSProperties = {
  fontSize: '12px',
  fontWeight: 400,
  color: '#3A3E45',
  fontFamily: 'Helvetica, sans-serif',
  lineHeight: '150%',
  letterSpacing: '-1%',
};

export default Events;
